"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatWithMeButtonText = exports.friendExistsAlreadyButtonText = exports.logInAddMeToYourFriendsButtonText = exports.addMeToYourFriendsButtonText = exports.loadingMessage = exports.friendExistsMessage = exports.friendWasAddedSuccesMessage = exports.internalErrorMessage = exports.userNotLoggedInErrorMessage = void 0;
//ERRORS & SUCCESS
//Same 'not logged in' error message like on 'Chat with me' button
exports.userNotLoggedInErrorMessage = "Current user not found! Not logged in?";
exports.internalErrorMessage = "An internal error occured!";
exports.friendWasAddedSuccesMessage = "Friend was added!";
//OTHER
exports.friendExistsMessage = "Friend already exists";
exports.loadingMessage = "Loading...";
//BUTTONS
exports.addMeToYourFriendsButtonText = "Add me to your friend list";
exports.logInAddMeToYourFriendsButtonText = "Login to add me to your friend list";
exports.friendExistsAlreadyButtonText = "Already part of friend list";
exports.chatWithMeButtonText = "Chat with me";
//# sourceMappingURL=texts.js.map